import React, { useCallback } from 'react';
import { Button, Modal, type ModalProps } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { clearErrorAction } from '../../ReduxSlices/errorSlice';
import toast from 'react-hot-toast';

interface IErrorDialogProps extends ModalProps {}

export default function ErrorDialog(props: IErrorDialogProps) {
  const { isOpen, error } = useAppSelector((state) => state.error_slice);
  const dispatch = useAppDispatch();

  const handleClose = useCallback(() => {
    dispatch(clearErrorAction());
  }, [dispatch]);

  const handleCopyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(error);
    toast.success('Copied to clipboard!', {
      id: 'copy-to-clipboard'
    });
  }, [error]);
  return (
    <Modal
      {...props}
      show={isOpen}
      size="lg"
      onHide={handleClose}
      aria-labelledby="logout-modal-centered"
      centered>
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title id="logout-modal-centered">{`Oops! Something went wrong.`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <code>
          <pre>{error}</pre>
        </code>
        <Button variant="light" onClick={handleCopyToClipboard}>
          Copy to clipboard
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={() => handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
